import styled from 'styled-components';
import { PROFILE_MAX_WIDTH, PROFILE_MIN_WIDTH, PROFILE_PADDING } from './Profile.meta';
import { Box } from '../CommonComponents/OPL/Box/Box';

interface ProfileWrapperProps {
  hasStickyFooter?: boolean;
}

export const ProfileWrapper = styled(Box)<ProfileWrapperProps>(({ hasStickyFooter }) => ({
  maxWidth: PROFILE_MAX_WIDTH,
  minWidth: PROFILE_MIN_WIDTH,
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: PROFILE_PADDING,
  minHeight: hasStickyFooter ? 'calc(100vh - 100px)' : 'unset',
}));
